import { render, staticRenderFns } from "./box.vue?vue&type=template&id=0ecf28cd&scoped=true&"
import script from "./box.vue?vue&type=script&lang=js&"
export * from "./box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf28cd",
  null
  
)

export default component.exports